module.exports = __webpack_public_path__ + "static/media/azure.a1d1d746.svg";